import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={44}
    height={44}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_15961_1280)">
      <circle
        cx={18}
        cy={18}
        r={18}
        transform="matrix(-1 0 0 1 40 0)"
        fill="white"
      />
      <circle
        cx={18}
        cy={18}
        r={17.5}
        transform="matrix(-1 0 0 1 40 0)"
        stroke="#EBF4FF"
      />
    </g>
    <path
      d="M24.5 11L17.5 18L24.5 25"
      stroke="#6791FF"
      strokeWidth={3}
      strokeLinecap="square"
    />
    <defs>
      <filter
        id="filter0_d_15961_1280"
        x={0}
        y={0}
        width={44}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.87666 0 0 0 0 0.87666 0 0 0 0 0.87666 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_15961_1280"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_15961_1280"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgComponent;
